module.exports = __webpack_public_path__ + "img/voteman.5c4757dd.jpg";